"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataDogRumService = void 0;
const tslib_1 = require("tslib");
const browser_rum_1 = require("@datadog/browser-rum");
// RUM requires one instance to be browser-rum to be used
// otherwise tracking is lost between #setUser, #init, other methods.
tslib_1.__exportStar(require("@datadog/browser-rum"), exports);
class DataDogRumService {
    constructor(tokenService) {
        this.tokenService = tokenService;
    }
    setUser() {
        var _a;
        let user;
        const tokenPayload = (_a = this.tokenService.getTokenContent()) === null || _a === void 0 ? void 0 : _a.payload;
        if (!tokenPayload || tokenPayload === undefined) {
            return;
        }
        const tokenType = tokenPayload.type;
        const isImpersonation = tokenType === 'impersonation';
        if (isImpersonation) {
            user = this.tokenService.getImpersonationSubjectOrUser();
        }
        else {
            user = tokenPayload.user;
        }
        if (!user) {
            return;
        }
        browser_rum_1.datadogRum.addRumGlobalContext('isImpersonation', isImpersonation);
        browser_rum_1.datadogRum.addRumGlobalContext('isC2FO', user.emailAddress.includes('@c2fo.com'));
        browser_rum_1.datadogRum.setUser({
            id: user.uuid,
            email: user.emailAddress,
        });
    }
}
exports.DataDogRumService = DataDogRumService;
//# sourceMappingURL=DataDogRUMService.js.map